import TaskGroups from 'containers/TaskManagement'
import React from 'react'

const TaskGroupsDashboard = () => {
  return (
    <TaskGroups/>
  )
}

export default TaskGroupsDashboard